module.exports = __webpack_public_path__ + "img/hezuo.8c2c41c8.png";